import 'babel-polyfill';
import 'whatwg-fetch';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};

import { Cookies } from 'js/components/Cookies/index.js';
import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Image } from 'js/components/Image/index-override.js';
import { LocationHours } from 'js/components/LocationHours/index.js';

import { SearchBoxInit } from 'js/common/modules/SearchBox.js';
import { SetUpGeolocation } from 'js/directory/modules/DirectoryGeolocation.js';
import { SetupAutocomplete } from 'js/directory/modules/AutocompleteSetup.js';
import { GetInlineRatings } from 'js/common/modules/InlineRatings.js';
import { EmailModal } from 'js/common/modules/EmailModal.js'
import { BackToTop } from 'js/common/modules/BackToTop.js';

require('script-loader!.tmp/js/templates/components/Modal/Modal-override.js');



Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  LocationHours.loadAndRun();
  SearchBoxInit();
  SetUpGeolocation();
  SetupAutocomplete();
  (new EmailModal).init();
  new BackToTop();

  let customCopy = document.querySelector(".CustomCopy");
  if (customCopy) {
    let links = customCopy.getElementsByTagName("a");
    for (let link of links) {
      if (!link.href.includes('agency.nationwide.com')) {
        link.setAttribute('target', '_blank');
      }
    }
  }

  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});
